module.exports = __webpack_public_path__ + "img/background_v3.187ffffe.png";